import { createAction, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../../../Application/store/store";
import { RStatus } from "../../../Application/types";
import { type SurveyAsset, type SurveyAnswers } from "../../types";

interface SurveyState {
  hasAccess?: boolean;
  status: RStatus;
  current?: SurveyAsset;
  errorMessage?: string | null;
}

const initialState: SurveyState = {
  hasAccess: true,
  status: RStatus.Idle,
  current: undefined,
  errorMessage: undefined,
};

const name = "survey";

const surveySlice = createSlice({
  name,
  initialState: initialState,
  reducers: {
    req(state, _: PayloadAction<{ id: number }>) {
      return { ...state, status: RStatus.Pending, hasAccess: true };
    },
    got(state, action: PayloadAction<{ current: SurveyState["current"] }>) {
      return {
        ...state,
        status: RStatus.Got,
        current: action.payload.current,
      };
    },
    err(state, action: PayloadAction<{ errorMessage: SurveyState["errorMessage"] }>) {
      return {
        ...state,
        status: RStatus.Error,
        errorMessage: action.payload.errorMessage,
      };
    },
    completeSurveyAsset(
      state,
      action: PayloadAction<{
        assetId: number;
        data: SurveyAnswers;
      }>,
    ) {
      return state;
    },
    restricted(state) {
      state.hasAccess = false;
      state.status = RStatus.Got;
    },
  },
});

// actions
export const { req, got, err, completeSurveyAsset, startSurveyAsset, restricted } = {
  ...surveySlice.actions,
  startSurveyAsset: createAction<number>(`${name}/start`),
};

// selectors
export const selectSurvey = (state: RootState) => state.assets.survey.current;
export const selectSurveyStatus = (state: RootState) => state.assets.survey.status;
export const selectSurveyError = (state: RootState) => state.assets.survey.errorMessage;
export const hasAccessSelector = (state: RootState) => state.assets.survey.hasAccess;

// reducers
export default surveySlice.reducer;
